import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TestnurseComponent } from './testnurse.component';

import { MyScheduleManagerComponent, JobApplicationsInfoPipe } from './testnurse2/myschedulemanager/myschedulemanager.component';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../../src/app/shared/auth/auth.service';
import { AuthGuard } from '../../../../../src/app/shared/auth/auth-guard.service';
import { ActorService } from '../../services/actor.service';
import { DOCService } from '../../services/doc.service';
import { HCPService } from '../../services/hcp.service';
import { LoginService } from '../../services/login.service';

import { AllCertificateListComponent } from '../testnurse/profile/allcertificatesview/allcertificatesview.component';
import { NurseProfileComponent } from '../testnurse/profile/nurseprofile.component';

import { ActorFormsV3Component } from './actorforms/version3/forms/actorformsv3.component';


import { ProviderDashboardComponent } from './provider/dashboard/providerdashboard.component';
import { ProfileViewComponent } from './profile/patientprofileview/profileview.component';
import { ServiceComponent } from './service/service.component';
import { ServiceConfigComponent } from './service/serviceconfig/serviceconfig.component';
import { CounsellingregistryComponent } from './follow up/counsellingregistry/counsellingregistry.component';
import { ActivityTrackingComponent } from './follow up/activitytracking/activitytracking.component';
import { BillingComponent } from '../billing/billing.component';
import { LabComponent } from '../lab/lab.component';
import { SchedularComponent } from '../schedular/schedular.component';
import { NewsComponent } from './News/news.component';
import { ArticlesComponent } from './Articles/articles.component';
import { NgbAddNewPatient } from './provider/dashboard/modal/addnewpatient.modal';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BGSComponent } from './service/Bgs/bgs.component';
import { TreatmentCycleComponent } from './ivf/TreatmentCycle/treatmentcycle.component';
import { IVFDashboardComponent } from './ivf/ivfdashboard/ivfdashboard.component';
import { MedicalRecordComponent } from './profile/patientprofileview/medicalrecord/medicalrecord.component';
import { VisitregisterComponent } from './visitregister/visitregister.component';
import { CodetypesComponent } from './codetypes/codetypes.component';
import { FdappointmentComponent } from './fdappointment/fdappointment.component';
import { LabsetupComponent } from './labsetup/labsetup.component';
import { OpBillingComponent } from './opbilling/opbilling.component';
import { ReceiptComponent } from './opbilling/receipt.component';
import { IVFWorkBenchComponent } from './ivf/ivfworkbench/ivfworkbench.component';
import { ScansOfTheDayComponent } from './ivf/ivfworkbench/scansoftheday.component';
import { IvfPickupEditComponent } from './ivf/ivfworkbench/ivfpickupedit.component';
import { IvfOQAeditComponent } from './ivf/ivfworkbench/ivfoqaedit.component';
import { IvfSemananeditComponent } from './ivf/ivfworkbench/ivfsemananedit.component';
import { IvfInseminationEditComponent } from './ivf/ivfworkbench/ivfinseminationedit.component';
import { IvfGradingeditComponent } from './ivf/ivfworkbench/ivfgradingedit.component';
import { FreezingComponent } from './ivf/ivfworkbench/freezing.component';
import { IvfETEditComponent } from './ivf/ivfworkbench/ivfetedit.component';
import { MISComponent } from './ivf/ivfworkbench/mis.component';
import { UsersComponent } from './users/users.component';
import { IvfmasterlistComponent } from './ivf/ivfmasterlist.component';
import { SessionComponent } from './session/session.component';
import { CryoStorageNewComponent } from './ivf/ivfworkbench/cryostoragenew.component';
import { IvfPickupReadyEditComponent } from './ivf/ivfworkbench/ivfpickupreadyedit.component';
import { IvfPregnancyEditComponent } from './ivf/ivfworkbench/ivfpregnancyedit.component';
import { BillViewComponent } from './opbilling/billview.component';
import { IvfHelpComponent } from './help/ivfhelp.component';
import { OpBillingEditComponent } from './opbilling/opbillingedit.component';
import { CryoPreservationComponent } from './ivf/ivfworkbench/cryopreservation.component';
import { VendorsComponent } from './erpsetup/vendors.component';
import { ItemCatalogueComponent } from './opbilling/itemcatalogue.component';
import { CustomerOrdersComponent } from './opbilling/customerorders.component';
import { ViewOrderComponent } from './opbilling/vieworder.component';
import { ExternaldoctorsComponent } from './masters/externaldoctors.component';
import { EmployeeComponent } from './masters/employee.component';
import { DepartmentsComponent } from './masters/departments.component';
import { BranchesComponent } from './masters/branches.component';
import { ModuleComponent } from './users/module.component';
import { RolesComponent } from './users/roles.component';
import { FeaturesComponent } from './users/features.component';
import { AccessRightsComponent } from './users/accessrights.component';
import { ReportAttributesComponent } from './reportsetup/reportattributes.component';
import { ReportRegisterComponent } from './reportsetup/reportregister.component';
import { IVFDashboard2Component } from './ivf/ivfdashboard/ivfdashboard2.component';
import { ApprovalListComponent } from './opbilling/approvallist.component';
import { RefundreqItemsComponent } from './opbilling/refundreqitems.component';
import { ExpenseVocherComponent } from './opbilling/expensevocher.component';
import { ExpenseManComponent } from './opbilling/expenseman.component';
import { IOHReceiptComponent } from './opbilling/iohreceipt.component';
import { IOHOrdersComponent } from './opbilling/iohorders.component';
import { IOHViewOrderComponent } from './opbilling/iohvieworder.component';
import { ConsumptionEntryDasComponent } from './consumptionentry/consumptionentrydas.component';
import { ConsumptionReceiptComponent } from './consumptionentry/consumptionreceipt.component';
import { MaterialConsumptionComponent } from './erpsetup/materialconsumption.component';
import { ConsumptionReceiptEditComponent } from './consumptionentry/consumptionreceiptedit.component';
import { FdappointmentAdvComponent } from './fdappointment/fdappointment(adv).component';
import { ReceiptOldComponent } from './opbilling/receiptold.component';
import { ReceiptEditComponent } from './opbilling/receiptedit.component';
import { RxReceiptComponent } from './opbilling/rxreceipt.component';
import { RefundReceiptComponent } from './opbilling/refundreceipt.component';
import { TreatmentCycle2Component } from './ivf/TreatmentCycle/treatmentcycle2.component';
import { PrescriptionreceiptComponent } from './opbilling/prescriptionreceipt.component';
import { RefundsDashboardComponent } from './opbilling/refundsdashboard.component';
import { RefundItemsComponent } from './opbilling/refundItems.component';
import { AdmissionsComponent } from './admissions/admissions.component';
import { NewAdmissionComponent } from './admissions/newadmission.component';
import { EditAdmissionComponent } from './admissions/editadmission.component';
import { ViewPharmBillingComponent } from './opbilling/viewpharmbilling.component';
import { LabDashboardComponent } from '../lab/labdashboard.component';
import { SpecimenCollection2Component } from '../lab/specimencollection2.component';
import { RxreceipteditComponent } from './opbilling/rxreceiptedit.component';
import { ResultsEntryComponent } from '../lab/resultsentry.component';
import { ServicesAdmissionComponent } from './admissions/servicesadmission.component';
import { IohAdmissionreceiptComponent } from './admissions/iohadmissionreceipt.component';
import { MedicinesAdmissionComponent } from './admissions/medicinesadmission.component';
import { BillAdmissionComponent } from './admissions/billadmission.component';
import { IpReceiptComponent } from './admissions/ipreceipt.component';
import { MaterialTrackingComponent } from './erpsetup/materialtracking.component';
import { BillVerficationComponent } from './opbilling/billverfication.component';
import { IPBillServicesTrackingComponent } from './opbilling/ipbillservicestracking.component';
import { OPBillServicesTrackingComponent } from './opbilling/opbillservicestracking.component';
import { ServicesRevenueComponent } from './erpsetup/servicesrevenue.component';
import { MaterialInvoiceComponent } from './opbilling/materialinvoice.component';
import { InvoiceReceiptComponent } from './opbilling/invoicereceipt.component';
//import { InvoiceReceiptEditComponent } from './opbilling/invoicereceiptedit.component';
import { InvoiceEditComponent } from './opbilling/invoiceedit.component';
import { IpBillVerficationComponent } from './opbilling/ipbillverfication.component';
import { ServiceTrackingReportComponent } from './opbilling/servicetrackingreport.component';
import { ExcelReportingComponent } from './Reporting/excelreporting.component';
import { NewDashboardComponent } from './dashboard/newdashboard.component';
import { DocDashboardComponent } from './dashboard/docdashboard.component';

import { DashboardSectionContainerComponent } from './ivf/ivfworkbench/dashboardsectioncontainer.component';
import { SmartPhoneMenuComponent } from './dashboard/smartphonemenu.component';
import { SmartPhonefdAppointmentComponent } from './fdappointment/smartphonefdappointment(adv).component';
import { SmartPhoneDocAppointmentsComponent } from './fdappointment/sp_doctorappointments.component';
import { PurchaseIndentComponent } from './opbilling/purchaseindent.component';
import { IndentAddComponent } from './opbilling/indentadd.component';
import { PurchaseOrderComponent } from './opbilling/purchaseorder.component';
import { PurchaseOrderEditComponent } from './opbilling/purchaseorderedit.component';
import { PurchaseOrderAddComponent } from './opbilling/purchaseorderadd.component';
import { MyWorkBookComponent } from './follow up/activitytracking/myworkbook.component';
import { DeptConsumptionEntryDasComponent } from './consumptionentry/deptconsumptionentrydas.component';
import { DeptConsumptionReceiptComponent } from './consumptionentry/deptconsumptionreceipt.component';
import { DeptConsumptionReceiptEditComponent } from './consumptionentry/deptconsumptionreceiptedit.component';
import { ActivityMonitoringComponent } from './follow up/activitytracking/activitymonitoring.component';
import { ServicesPanelComponent } from './service/servicespanel.component';
import { ActivityMonitoring2Component } from './follow up/activitytracking/activitymonitoring2.component';
import { CombinedBillingComponent } from './opbilling/combinedbilling.component';
import { CombinedAddBillingComponent } from './opbilling/combinedaddbilling.component';
import { ReceiptServiceProviderComponent } from './opbilling/receipt_svcprovider.component';
import { ReceiptEditServiceProviderComponent } from './opbilling/receiptedit_svcprovider.component';
import { CustDashboardComponent } from './dashboard/custdashboard.component';
import { ProfileViewHComponent } from './profile/patientprofileview/profileviewh.component';
import { IPReceiptEditServiceProviderComponent } from './opbilling/IPreceiptedit_svcprovider.component';
import { PatientProfileViewComponent } from './profile/patientprofileview/patientprofileview.component';
import { POVIComponent } from './opbilling/povi.component';
import { POVIAddComponent } from './opbilling/poviadd.component';
import { POVIEditComponent } from './opbilling/poviedit.component';
import { PurchaseOrderAdd_DiscComponent } from './opbilling/purchaseorderadd_disc.component';
import { PurchaseOrderEdit_DiscComponent } from './opbilling/purchaseorderedit_disc.component';
import { InvoiceReceipt_DiscComponent } from './opbilling/invoicereceipt_disc.component';
import { InvoiceEdit_DiscComponent } from './opbilling/invoiceedit_disc.component';
import { ProfileViewPartnerComponent } from './profile/patientprofileview/profileviewpartner.component';
import { EggDonorDashboardComponent } from './ivf/ivfdashboard/eggdonordashboard.component';
import { EggDonorEpisodeComponent } from './ivf/TreatmentCycle/eggdonorepisode.component';
import { FollicularScansDashboardComponent } from './ivf/ivfdashboard/follicularscansdashboard.component';
import { FollicularScanEpisodeComponent } from './ivf/TreatmentCycle/follicularscanepisode.component';
import { OpBillingPPComponent } from './opbilling/opbillingpp.component';
import { OpBillingNPComponent } from './opbilling/opbillingnp.component';
//import { ExpenseManagementComponent } from './opbilling/expensemanagement.component';
//import { ApprovalsComponent } from './opbilling/approvals.component';
//import { TreatmentCycleComponent } from './ivf/TreatmentCycle/treatmentcycle';
//import { CounsellingRegisterComponent } from './followup/counsellingregister/counsellingregister.component';
//const routes: Routes = [
//  {
//    path: '', redirectTo: 'signinpage',
//    pathMatch: 'full'
//  },
//  {
//    path: 'signinpage', component: LoginModuleComponent
//  },

//];

@NgModule({
  imports: [
    //RouterModule.forRoot(routes)
    RouterModule.forChild([
      {
        path: 'healins', component: TestnurseComponent, canActivate: [AuthGuard],

        children: [

          { path: 'dashboardsection', component: DashboardSectionContainerComponent, canActivate: [AuthGuard] },
          { path: 'latestdashboard', component: NewDashboardComponent, canActivate: [AuthGuard] },
          { path: 'docdashboard', component: DocDashboardComponent, canActivate: [AuthGuard] },
          { path: 'smartphonefdappointment', component: SmartPhonefdAppointmentComponent, canActivate: [AuthGuard] },
          { path: 'sm_doc_appts', component: SmartPhoneDocAppointmentsComponent, canActivate: [AuthGuard] },
          { path: 'dashboard', component: ProviderDashboardComponent, canActivate: [AuthGuard] },
          { path: 'newdashboard', component: DashboardComponent, canActivate: [AuthGuard] },
          { path: 'service', component: ServiceComponent, canActivate: [AuthGuard] },
          { path: 'bgs', component: BGSComponent, canActivate: [AuthGuard] },
          { path: 'serviceconfig', component: ServiceConfigComponent, canActivate: [AuthGuard] },
          {
            path: 'schedulemanager', component: MyScheduleManagerComponent, canActivate: [AuthGuard]
          },
          {
            path: 'ApprovalList', component: ApprovalListComponent, canActivate: [AuthGuard]
          },
          {
            path: 'Expensevo', component: ExpenseVocherComponent, canActivate: [AuthGuard]
          },

          {
            path: 'ExpenseManagement', component: ExpenseManComponent, canActivate: [AuthGuard]
          },
          { path: 'ipreceipt', component: IpReceiptComponent, canActivate: [AuthGuard] },
          {
            path: 'Refundrequest', component: RefundreqItemsComponent, canActivate: [AuthGuard]
          },
          { path: 'allcertificatelist', component: AllCertificateListComponent, canActivate: [AuthGuard] },
          { path: 'profile', component: NurseProfileComponent, canActivate: [AuthGuard] },

          { path: 'actorformsv3', component: ActorFormsV3Component, canActivate: [AuthGuard] },
          { path: 'MaterialTracking', component: MaterialTrackingComponent, canActivate: [AuthGuard] },
          { path: 'news', component: NewsComponent, canActivate: [AuthGuard] },
          { path: 'articles', component: ArticlesComponent, canActivate: [AuthGuard] },
          { path: 'profileview', component: ProfileViewComponent, canActivate: [AuthGuard] },
          { path: 'profileviewh', component: ProfileViewHComponent, canActivate: [AuthGuard] },
          { path: 'counsellingregister', component: CounsellingregistryComponent, canActivate: [AuthGuard] },
          { path: 'dailyworkbook', component: ActivityTrackingComponent, canActivate: [AuthGuard] },
          { path: 'billing', component: BillingComponent, canActivate: [AuthGuard] },
          { path: 'lab', component: LabComponent, canActivate: [AuthGuard] },
          { path: 'TreatmentCycle', component: TreatmentCycleComponent, canActivate: [AuthGuard] },
          //{ path: 'NewPatient', component: NgbAddNewPatient, canActivate: [AuthGuard] },
          { path: 'Schedular', component: SchedularComponent, canActivate: [AuthGuard] },
          { path: 'ivfdashboard', component: IVFDashboardComponent, canActivate: [AuthGuard] },
          { path: 'ivfdashboard2', component: IVFDashboard2Component, canActivate: [AuthGuard] },
          { path: 'medicalrecordnew', component: MedicalRecordComponent, canActivate: [AuthGuard] },
          { path: 'visitreg', component: VisitregisterComponent, canActivate: [AuthGuard] },
          { path: 'CodeTypes', component: CodetypesComponent, canActivate: [AuthGuard] },
          { path: 'fdappoinment', component: FdappointmentComponent, canActivate: [AuthGuard] },
          { path: 'treatmentcycle2', component: TreatmentCycle2Component, canActivate: [AuthGuard] },
          { path: 'fdappoinmentadv', component: FdappointmentAdvComponent, canActivate: [AuthGuard] },
          { path: 'labstep', component: LabsetupComponent, canActivate: [AuthGuard] },
          { path: 'opbilling', component: OpBillingComponent, canActivate: [AuthGuard] },
          { path: 'billverfication', component: BillVerficationComponent, canActivate: [AuthGuard] },
          { path: 'prescriptionre', component: PrescriptionreceiptComponent, canActivate: [AuthGuard] },
          { path: 'receipt', component: ReceiptComponent, canActivate: [AuthGuard] },
          { path: 'receipt_svcprovider', component: ReceiptServiceProviderComponent, canActivate: [AuthGuard] },
          { path: 'receiptedit_svcprovider', component: ReceiptEditServiceProviderComponent, canActivate: [AuthGuard] },
          { path: 'rxreceipt', component: RxReceiptComponent, canActivate: [AuthGuard] },
          { path: 'receiptedit', component: ReceiptEditComponent, canActivate: [AuthGuard] },
          { path: 'refundslist', component: RefundsDashboardComponent, canActivate: [AuthGuard] },
          { path: 'refundreceipt', component: RefundReceiptComponent, canActivate: [AuthGuard] },
          { path: 'refundItems', component: RefundItemsComponent, canActivate: [AuthGuard] },
          { path: 'receiptold', component: ReceiptOldComponent, canActivate: [AuthGuard] },
          { path: 'iohreceipt', component: IOHReceiptComponent, canActivate: [AuthGuard] },
          { path: 'ivfworkbench', component: IVFWorkBenchComponent, canActivate: [AuthGuard] },
          { path: 'ivfscans', component: ScansOfTheDayComponent, canActivate: [AuthGuard] },
          { path: 'ivfpickups', component: IvfPickupEditComponent, canActivate: [AuthGuard] },
          { path: 'ivfpickupsready', component: IvfPickupReadyEditComponent, canActivate: [AuthGuard] },
          { path: 'ivfoqa', component: IvfOQAeditComponent, canActivate: [AuthGuard] },
          { path: 'ivfsemen', component: IvfSemananeditComponent, canActivate: [AuthGuard] },
          { path: 'ivfinsemination', component: IvfInseminationEditComponent, canActivate: [AuthGuard] },
          { path: 'ivfembryograding', component: IvfGradingeditComponent, canActivate: [AuthGuard] },
          { path: 'ivffreezing', component: FreezingComponent, canActivate: [AuthGuard] },
          { path: 'ivfembryotransfer', component: IvfETEditComponent, canActivate: [AuthGuard] },
          { path: 'ivfpregnancytracker', component: IvfPregnancyEditComponent, canActivate: [AuthGuard] },
          { path: 'mis', component: MISComponent, canActivate: [AuthGuard] },
          { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
          { path: 'ivfmasterlist', component: IvfmasterlistComponent, canActivate: [AuthGuard] },
          { path: 'Session', component: SessionComponent, canActivate: [AuthGuard] },
          { path: 'Cryo2', component: CryoStorageNewComponent, canActivate: [AuthGuard] },
          { path: 'ConsumptionEntry', component: ConsumptionEntryDasComponent, canActivate: [AuthGuard] },
          { path: 'Consumptionreceipt', component: ConsumptionReceiptComponent, canActivate: [AuthGuard] },
          { path: 'Consumptionreceipt2', component: ConsumptionReceiptEditComponent, canActivate: [AuthGuard] },
          { path: 'MedicalRecords', component: MedicalRecordComponent, canActivate: [AuthGuard] },
          { path: 'latestdashboard2', component: SmartPhoneMenuComponent, canActivate: [AuthGuard] },
          { path: 'billview', component: BillViewComponent, canActivate: [AuthGuard] },
          { path: 'ivfhelp', component: IvfHelpComponent, canActivate: [AuthGuard] },
          { path: 'pharmacybill', component: ViewPharmBillingComponent, canActivate: [AuthGuard] },
          { path: 'SpecimenCollection2', component: SpecimenCollection2Component, canActivate: [AuthGuard] },
          { path: 'labdas', component: LabDashboardComponent, canActivate: [AuthGuard] },
          { path: 'opbillingedit', component: OpBillingEditComponent, canActivate: [AuthGuard] },
          { path: 'cryopre', component: CryoPreservationComponent, canActivate: [AuthGuard] },
          { path: 'vendors', component: VendorsComponent, canActivate: [AuthGuard] },
          { path: 'itemcatalogue', component: ItemCatalogueComponent, canActivate: [AuthGuard] },
          { path: 'customerorders', component: CustomerOrdersComponent, canActivate: [AuthGuard] },
          { path: 'iohorders', component: IOHOrdersComponent, canActivate: [AuthGuard] },
          { path: 'vieworder', component: ViewOrderComponent, canActivate: [AuthGuard] },
          { path: 'iohvieworder', component: IOHViewOrderComponent, canActivate: [AuthGuard] },
          { path: 'externaldoctors', component: ExternaldoctorsComponent, canActivate: [AuthGuard] },
          { path: 'employee', component: EmployeeComponent, canActivate: [AuthGuard] },
          { path: 'resultsen', component: ResultsEntryComponent, canActivate: [AuthGuard] },
          { path: 'departments', component: DepartmentsComponent, canActivate: [AuthGuard] },
          { path: 'branches', component: BranchesComponent, canActivate: [AuthGuard] },
          { path: 'module', component: ModuleComponent, canActivate: [AuthGuard] },
          { path: 'roles', component: RolesComponent, canActivate: [AuthGuard] },
          { path: 'features', component: FeaturesComponent, canActivate: [AuthGuard] },
          { path: 'accessrights', component: AccessRightsComponent, canActivate: [AuthGuard] },
          { path: 'reportattributes', component: ReportAttributesComponent, canActivate: [AuthGuard] },
          { path: 'reportregister', component: ReportRegisterComponent, canActivate: [AuthGuard] },
          { path: 'materialconsumption', component: MaterialConsumptionComponent, canActivate: [AuthGuard] },
          { path: 'admissions', component: AdmissionsComponent, canActivate: [AuthGuard] },
          { path: 'newadmission', component: NewAdmissionComponent, canActivate: [AuthGuard] },
          { path: 'rxreceiptedit', component: RxreceipteditComponent, canActivate: [AuthGuard] },
          { path: 'editadmission', component: EditAdmissionComponent, canActivate: [AuthGuard] },
          { path: 'servicesadmission', component: ServicesAdmissionComponent, canActivate: [AuthGuard] },
          { path: 'iohadmissionreceipt', component: IohAdmissionreceiptComponent, canActivate: [AuthGuard] },
          { path: 'medicinesadmission', component: MedicinesAdmissionComponent, canActivate: [AuthGuard] },
          { path: 'billadmission', component: BillAdmissionComponent, canActivate: [AuthGuard] },
          { path: 'ipbillservicestra', component: IPBillServicesTrackingComponent, canActivate: [AuthGuard] },
          { path: 'opbillservicestra', component: OPBillServicesTrackingComponent, canActivate: [AuthGuard] },
          { path: 'servicesrevenue', component: ServicesRevenueComponent, canActivate: [AuthGuard] },
          { path: 'materialinvoice', component: MaterialInvoiceComponent, canActivate: [AuthGuard] },
          { path: 'invoicereceipt', component: InvoiceReceiptComponent, canActivate: [AuthGuard] },
          { path: 'invoicereceiptedit', component: InvoiceEditComponent, canActivate: [AuthGuard] },
          { path: 'ipbillverfication', component: IpBillVerficationComponent, canActivate: [AuthGuard] },
          { path: 'strackingreport', component: ServiceTrackingReportComponent, canActivate: [AuthGuard] },
          { path: 'excelreporting', component: ExcelReportingComponent, canActivate: [AuthGuard] },
          { path: 'purchaseindent', component: PurchaseIndentComponent, canActivate: [AuthGuard] },
          { path: 'indentadd', component: IndentAddComponent, canActivate: [AuthGuard] },
          { path: 'purchaseorder', component: PurchaseOrderComponent, canActivate: [AuthGuard] },
          { path: 'purchaseorderedit', component: PurchaseOrderEditComponent, canActivate: [AuthGuard] },
          { path: 'purchaseorderadd', component: PurchaseOrderAddComponent, canActivate: [AuthGuard] },
          { path: 'myworkbook', component: MyWorkBookComponent, canActivate: [AuthGuard] },
          { path: 'deptconsumptionentrydas', component: DeptConsumptionEntryDasComponent, canActivate: [AuthGuard] },
          { path: 'deptconsumptionreceipt', component: DeptConsumptionReceiptComponent, canActivate: [AuthGuard] },
          { path: 'deptconsumptionreceiptedit', component: DeptConsumptionReceiptEditComponent, canActivate: [AuthGuard] },
          { path: 'activitymonitoring2', component: ActivityMonitoring2Component, canActivate: [AuthGuard] },
          { path: 'servicespanel', component: ServicesPanelComponent, canActivate: [AuthGuard] },
          { path: 'combinedbilling', component: CombinedBillingComponent, canActivate: [AuthGuard] },
          { path: 'combinedaddbilling', component: CombinedAddBillingComponent, canActivate: [AuthGuard] }, 
          { path: 'custdashboard', component: CustDashboardComponent, canActivate: [AuthGuard] }, 
          { path: 'IPreceiptedit_svcprovider', component: IPReceiptEditServiceProviderComponent, canActivate: [AuthGuard] },
          { path: 'patientprofileview', component: PatientProfileViewComponent, canActivate: [AuthGuard] },
          { path: 'povi', component: POVIComponent, canActivate: [AuthGuard] },
          { path: 'poviadd', component: POVIAddComponent, canActivate: [AuthGuard] },
          { path: 'poviedit', component: POVIEditComponent, canActivate: [AuthGuard] },
          { path: 'purchaseorderadd_disc', component: PurchaseOrderAdd_DiscComponent, canActivate: [AuthGuard] },
          { path: 'purchaseorderedit_disc', component: PurchaseOrderEdit_DiscComponent, canActivate: [AuthGuard] },
          { path: 'invoicereceipt_disc', component: InvoiceReceipt_DiscComponent, canActivate: [AuthGuard] },
          { path: 'profileviewpartner', component: ProfileViewPartnerComponent, canActivate: [AuthGuard] },
          { path: 'invoiceedit_disc', component: InvoiceEdit_DiscComponent, canActivate: [AuthGuard] },
          { path: 'eggdonordashboard', component: EggDonorDashboardComponent, canActivate: [AuthGuard] },
          { path: 'eggdonorepisode', component: EggDonorEpisodeComponent, canActivate: [AuthGuard] },
          { path: 'follicularscansdashboard', component: FollicularScansDashboardComponent, canActivate: [AuthGuard] },
          { path: 'follicularscanepisode', component: FollicularScanEpisodeComponent, canActivate: [AuthGuard] },
          { path: 'opbillingpp', component: OpBillingPPComponent, canActivate: [AuthGuard] },
          { path: 'opbillingnp', component: OpBillingNPComponent, canActivate: [AuthGuard] }
        ]

      },
    ])
  ],
  providers: [
    TranslateModule,
    //Toastr and auth providers
    // { provide: ToastOptions, useClass: CustomOption },
    AuthService,
    AuthGuard,
    ActorService,
    DOCService,
    HCPService,
    LoginService,
    TranslateService,

  ],
  //exports: [RouterModule]
})
export class TestnurseRoutingModule { }
